// Section background tones for the landing page — and the rule that keeps two
// connected sections from sharing a background.
//
// Every flow section takes a `tone`, assigned in one place (Home) so the whole
// page's background rhythm is a single source of truth rather than each section
// hardcoding its own background. `assertNoAdjacentTones` enforces the rule at
// dev time: reorder or insert a section and it throws if two connected sections
// end up sharing a tone. "navy" is the dark-blue island (same scheme as the
// hero form card and the closing CTA); it flips text to the light set via the
// design system's `dark` class. "tint" is a soft brand-teal wash for a light
// section that still reads distinct from the neutral page/surface tones.
export type SectionTone = "page" | "surface" | "tint" | "navy"

export const toneBg: Record<SectionTone, string> = {
  page: "bg-page",
  surface: "bg-surface",
  tint: "bg-accent-faded",
  navy: "navy-panel dark",
}

// Dev-only guard for the "no two connected sections share a background" rule.
// Pass the ordered tones of the page's sections. Throws in development if any
// two neighbours match; a no-op in production.
export function assertNoAdjacentTones(tones: SectionTone[]): void {
  if (!import.meta.env.DEV) return
  for (let i = 1; i < tones.length; i++) {
    if (tones[i] === tones[i - 1]) {
      throw new Error(
        `Connected sections share a "${tones[i]}" background (positions ${i - 1} and ${i}). ` +
          "Adjust the tones in Home so neighbouring sections alternate.",
      )
    }
  }
}
